import { graphql } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';
import TermsAndConditions from '../components/legal-documents/terms-and-conditions/terms-and-conditions.component';
import PageBanner from '../components/page-banner/page-banner.component';

export const query = graphql`
  query StrapiTermsAndConditions {
    strapiTermsAndConditions(status: { eq: "published" }) {
      content
      updated_at
    }
  }
`;

type TermsAndConditionsPageProps = {
  data: GatsbyTypes.StrapiTermsAndConditionsQuery;
};

const TermsAndConditionsPage: React.FC<TermsAndConditionsPageProps> = ({
  data: {
    strapiTermsAndConditions: { content, updated_at },
  },
}) => {
  return (
    <>
      <Helmet title="Terms and Conditions" />
      <PageBanner
        pageTitle="Terms of Service"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Terms of Service"
      />
      <TermsAndConditions {...{ content }} lastModified={updated_at} />
    </>
  );
};

export default TermsAndConditionsPage;
